export default "__VITE_ASSET__BPChK7zl__"